module.exports = __webpack_public_path__ + "img/moped.c0080f92.jpg";